import { useContext } from 'react';
import { SessionContext } from '../../../js/app/contexts/SessionContext';
import { hasPermission } from '../utils/permissions';

/**
 * Does the current user hold this permission code? Works for every audience:
 * org reps get their AuthGroup codes, staff get their portal_* group codes (a
 * superuser gets every code) — see utils/permissions.ts. The staff user type
 * itself grants nothing here.
 */
export function useHasPermission(permission: string) {
  const { user } = useContext(SessionContext);
  return hasPermission(user, permission);
}
